import moment from 'moment';

// Only import the moment locales you need
import 'moment/locale/es';
import 'moment/locale/fr-ca';
// import 'moment/locale/ar';

import enUS from 'antd/lib/locale-provider/en_US';
import esES from 'antd/lib/locale-provider/es_ES';
import frFR from 'antd/lib/locale-provider/fr_FR';

// ---- single declaration ----
const locales = {
  en: enUS,
  es: esES,
  'fr-CA': frFR,
};

// Named export (what index.js imports)
export { locales as antdLocales };

// Named export for moment locale mapping
export function applyMomentLocale(lng) {
  const map = {
    en: 'en',
    es: 'es',
    'fr-CA': 'fr-ca',
  };
  moment.locale(map[lng] || 'en');
}

export default {
  antdLocales: locales,
  applyMomentLocale,
};
